export const REQUEST_METHOD_LIST:string = "view";

export const REQUEST_METHOD_ADD: string = "add";

export const REQUEST_METHOD_EDIT: string = "edit";

export const REQUEST_METHOD_DELETE: string = "delete";

export const REQUEST_METHOD_FULL: string = "F";



// WEBPACK FOOTER //
// ./src/app/domain/const/request-method.const.ts